import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "rest-действия",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#rest-%D0%B4%D0%B5%D0%B9%D1%81%D1%82%D0%B2%D0%B8%D1%8F",
        "aria-label": "rest действия permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`REST действия`}</h1>
    <p>{`Приложение для выполнения запросов к REST API Битрикс24 с помощью действия из стандартного конструктора бизнес-процессов.`}</p>
    <br />
    <p>{`Обязательное требование для работы приложения - наличие бизнес-процессов в Вашем Битрикс24.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Тарифы облака:`}</strong>{` Команда, Компания, CRM+ Архивный.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Коробочная версия 1С-Битрикс:`}</strong>{` Все.`}</p>
    <p><strong parentName="p">{`При устанвоке в коробочную версию 1С-Битрикс выдаст ошибку`}</strong>{` Для её устранения пришлите адрес портала `}<a parentName="p" {...{
        "href": "https://getmorecash.bitrix24.ru/online/restapi",
        "title": "в открытую линию технической поддержки"
      }}>{`в открытую линию технической поддержки`}</a>{`. В остальном приложение в коробке работает штатно.`}</p>
    <p><a parentName="p" {...{
        "href": "/getting-started"
      }}>{`Начало работы`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      